// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3D9dU","content":"Consent_content__2oeJ7","footer":"Consent_footer__3OKD8"};